<script>
  import { Lenex } from "js-lenex";

  export let lenex = null;

  const onFileSelected = async e => {
    let file = e.target.files[0];
    const len = new Lenex(file);
    await len.init();
    lenex = len;
  };
</script>

<style>
  @media print {
    input {
      display: none !important;
    }
  }
</style>

<input type="file" accept=".lxf, .lef" on:change={(e)=>onFileSelected(e)} >